import upperFirst from 'lodash/upperFirst'
import pickBy from 'lodash/pickBy'
import reduce from 'lodash/reduce'

export const refElements = {
  CONTAINER: 'container',
  SECTION: 'section',
  TEXT: 'text',
  DIV: 'block',
  BUTTON: 'button',
  DIVIDER: 'divider',
  COLUMNS: 'columns',
  COLUMN: 'column',
  CARD: 'card',
  IMAGE: 'image',
  MENUS: 'menus',
  CATEGORY_MENUS: 'categoryMenus',
  IMAGE_CAROUSEL: 'imageCarousel',
  CARD_GROUP: 'cardGroup',
  COUNT_DOWN: 'countDown',
  PRODUCT_CARD: 'productCard',
  PRODUCT_SLIDER: 'productSlider',
  YOUTUBE: 'youtube',
  TEXT_EDITOR: 'textEditor',
}

const contentTab = { tabLabel: 'Content', tabValue: 'content' }
const settingsTab = { tabLabel: 'Settings', tabValue: 'settings' }
const stylesTab = { tabLabel: 'Style', tabValue: 'styles' }
const backgroundTab = { tabLabel: 'BG', tabValue: 'background' }
const effectTab = { tabLabel: 'Effect', tabValue: 'effect' }

export const elementTabs = {
  [refElements.COLUMNS]: [contentTab, settingsTab, stylesTab, backgroundTab],
  [refElements.SECTION]: [stylesTab, backgroundTab],
  [refElements.DIV]: [stylesTab, backgroundTab],
  [refElements.CONTAINER]: [stylesTab, settingsTab, backgroundTab],
  [refElements.TEXT]: [contentTab, stylesTab, backgroundTab],
  [refElements.CARD]: [contentTab, stylesTab, settingsTab],
  [refElements.IMAGE]: [contentTab, stylesTab, effectTab, backgroundTab],
  [refElements.BUTTON]: [contentTab, stylesTab],
  [refElements.DIVIDER]: [contentTab, stylesTab],
  [refElements.CATEGORY_MENUS]: [contentTab, stylesTab],
  [refElements.IMAGE_CAROUSEL]: [contentTab, stylesTab, settingsTab],
  [refElements.CARD_GROUP]: [stylesTab],
  [refElements.COUNT_DOWN]: [contentTab, stylesTab, backgroundTab],
  [refElements.PRODUCT_CARD]: [contentTab, settingsTab],
  [refElements.YOUTUBE]: [contentTab, settingsTab],
  [refElements.PRODUCT_SLIDER]: [contentTab, settingsTab],
  [refElements.TEXT_EDITOR]: [contentTab, stylesTab],
}

/**
 * This function will filter those key that have value (not equal '')
 * @param object
 * @returns object of valid keys
 */
export const filterValidStyles = (object) => (
  pickBy(object, (value) => value !== '')
)

/**
 * create side object for ex. padding, margin
 * able to add prefix and/or suffix
 * @param top
 * @param right
 * @param bottom
 * @param left
 * @param options
 * @returns {{}}
 */
export const createSideObject = (top, right, bottom, left, options = { pre: '', suf: '' }) => {
  const { pre, suf } = options
  return {
    [`${pre || ''}Top${suf ? upperFirst(suf) : ''}`]: top,
    [`${pre || ''}Bottom${suf ? upperFirst(suf) : ''}`]: bottom,
    [`${pre || ''}Left${suf ? upperFirst(suf) : ''}`]: left,
    [`${pre || ''}Right${suf ? upperFirst(suf) : ''}`]: right,
  }
}

/**
 * flatten one level deep of object
 * @param styles
 * @returns {*}
 */
export const flattenObject = (styles) => reduce(styles, (result, val) => ({
  ...result,
  ...val,
}), {})



// WEBPACK FOOTER //
// ./src/components/Canvas/renderer/utils/elementUtils.js